import { render, staticRenderFns } from "./NewScopeForm.vue?vue&type=template&id=ded8df0a&scoped=true&"
import script from "./NewScopeForm.vue?vue&type=script&lang=js&"
export * from "./NewScopeForm.vue?vue&type=script&lang=js&"
import style0 from "./NewScopeForm.vue?vue&type=style&index=0&id=ded8df0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded8df0a",
  null
  
)

export default component.exports